import { NavLink, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useCookies } from "react-cookie";

import {
  HiArrowLeftOnRectangle,
  HiArrowRightOnRectangle,
  HiOutlineBanknotes,
  HiOutlineBuildingLibrary,
  HiOutlineQuestionMarkCircle,
  HiOutlineShieldCheck,
  HiOutlineUserCircle,
} from "react-icons/hi2";

import classes from "./Nav.module.css";
import { logOut } from "../../api/api";
import { alertActions } from "../../store/alert-slice";
import { authActions } from "../../store/auth-slice";

const Nav = ({ onNavigate }) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const dispatch = useDispatch();
  const setCookie = useCookies(["jwt"])[1];
  const navigate = useNavigate();

  const afterNav = () => {
    onNavigate?.();
  };

  const logoutHander = async () => {
    afterNav();
    const res = await logOut();
    if (res.status === "success") {
      dispatch(authActions.logout());
      dispatch(
        alertActions.setState({ message: res.message, status: res.status })
      );
      setCookie("jwt", res.token);
      navigate("/", { replace: true });
    } else {
      dispatch(
        alertActions.setState({
          message: "Something went wrong",
          status: "error",
        })
      );
    }
    setTimeout(() => {
      dispatch(alertActions.resetState());
    }, 3000);
  };
  return (
    <nav className={classes.nav} id="primary-navigation">
      <NavLink
        to="banking"
        className={(navData) => (navData.isActive ? classes.active : "")}
        onClick={afterNav}
      >
        <span className={classes.linkInner}>
          <HiOutlineBuildingLibrary className={classes.linkIcon} aria-hidden />
          Banking
        </span>
      </NavLink>
      <NavLink
        to="borrowing"
        className={(navData) => (navData.isActive ? classes.active : "")}
        onClick={afterNav}
      >
        <span className={classes.linkInner}>
          <HiOutlineBanknotes className={classes.linkIcon} aria-hidden />
          Borrowing
        </span>
      </NavLink>
      <NavLink
        to="insurance"
        className={(navData) => (navData.isActive ? classes.active : "")}
        onClick={afterNav}
      >
        <span className={classes.linkInner}>
          <HiOutlineShieldCheck className={classes.linkIcon} aria-hidden />
          Insurance
        </span>
      </NavLink>
      <NavLink
        to="help"
        className={(navData) => (navData.isActive ? classes.active : "")}
        onClick={afterNav}
      >
        <span className={classes.linkInner}>
          <HiOutlineQuestionMarkCircle
            className={classes.linkIcon}
            aria-hidden
          />
          Help
        </span>
      </NavLink>
      {!isLoggedIn && (
        <NavLink
          to="login"
          className={(navData) => (navData.isActive ? classes.active : "")}
          onClick={afterNav}
        >
          <span className={classes.linkInner}>
            <HiArrowRightOnRectangle className={classes.linkIcon} aria-hidden />
            Login
          </span>
        </NavLink>
      )}
      {isLoggedIn && (
        <NavLink
          to="login"
          className={(navData) => (navData.isActive ? classes.active : "")}
          onClick={logoutHander}
        >
          <span className={classes.linkInner}>
            <HiArrowLeftOnRectangle className={classes.linkIcon} aria-hidden />
            Logout
          </span>
        </NavLink>
      )}
      {isLoggedIn && (
        <NavLink
          to="account"
          className={(navData) => (navData.isActive ? classes.active : "")}
          onClick={afterNav}
        >
          <span className={classes.linkInner}>
            <HiOutlineUserCircle className={classes.linkIcon} aria-hidden />
            My account
          </span>
        </NavLink>
      )}
    </nav>
  );
};

export default Nav;
